import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useOrganization } from '@/hooks/useOrganization';
import { PageHeader } from '@/components/layout/PageHeader';
import { HelpTooltip } from '@/components/ui/HelpTooltip';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Skeleton } from '@/components/ui/skeleton';
import { ActiveGapsTab } from '@/components/knowledge-gaps/ActiveGapsTab';
import { TriggerPipelineTab } from '@/components/knowledge-gaps/TriggerPipelineTab';
import { RunHistoryTab } from '@/components/knowledge-gaps/RunHistoryTab';

type TabValue = 'active-gaps' | 'trigger-pipeline' | 'run-history';

const KnowledgeGapsPage: React.FC = () => {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id;
  const [activeTab, setActiveTab] = useState<TabValue>('active-gaps');

  if (!orgId) {
    return (
      <>
        <PageHeader title="Knowledge Gaps" />
        <div className="px-4 sm:px-6 md:px-8 py-6 space-y-4">
          <Skeleton className="h-10 w-80" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-64 w-full" />
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Knowledge Gaps | Hobbes</title>
      </Helmet>
      <PageHeader title={<>Knowledge Gaps <HelpTooltip text="Topics your agent struggled with or couldn't answer." /></>} />
      <div className="px-4 sm:px-6 md:px-8 py-6">
        <Tabs
          value={activeTab}
          onValueChange={(v) => setActiveTab(v as TabValue)}
        >
          <TabsList className="mb-6">
            <TabsTrigger value="active-gaps">Active Gaps</TabsTrigger>
            <TabsTrigger value="trigger-pipeline">Run Analysis</TabsTrigger>
            <TabsTrigger value="run-history">Run History</TabsTrigger>
          </TabsList>

          <TabsContent value="active-gaps">
            <ActiveGapsTab orgId={orgId} />
          </TabsContent>
          <TabsContent value="trigger-pipeline">
            <TriggerPipelineTab orgId={orgId} />
          </TabsContent>
          <TabsContent value="run-history">
            <RunHistoryTab orgId={orgId} />
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
};

export default KnowledgeGapsPage;
